<template>
    <el-table ref="multipleTableRef" :data="tableData" :show-overflow-tooltip="true"
        @selection-change="(val) => emits('needDeleteRow', val)">
        <!-- <el-table-column v-if="index === true" label="编号" type="index" width="55" :align="align">
        </el-table-column>
        <el-table-column v-if="select === true" type="selection" width="55" :align="align" :reserve-selection="true">
        </el-table-column> -->
        <el-table-column v-for="(item, index) in props" :key="index" :property="item.prop" :label="item.label"
            :width="item.width">
            <template #default="{ row }">
                <span v-show="!item?.slots">
                    {{ row[item.prop] }}
                </span>
                <div v-show="item?.slots">
                    <slot :name="item?.slots" :row="row"></slot>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="180" v-show="operate === true">
        <template #default="scope">
          <el-button @click="handleEdit(scope.$index, scope.row)"> 升级详情 </el-button>
          <el-button @click="handleEdit1(scope.$index, scope.row)"> 终止任务 </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
</template>

<script>
export default {
    props: {
        tableData: Array,
        props: Array,
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style lang="less" scoped>
.el-table {
    --el-table-header-bg-color: #fafafd;
    --el-table-row-hover-bg-color: #fafafd;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    // height: 100%;
    // flex: 1;
    min-height: 100px;
    overflow: auto;

    ::v-deep .el-table__cell {
        padding: 0px;
        height: 36px;
        color: #333;
        font-size: 12px;

        .el-checkbox__input.is-checked {
            .el-checkbox__inner {
                background-color: var(--el-color-primary);
            }
        }

        .el-checkbox__inner {
            width: 16px;
            height: 16px;

            &:after {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -2px;
                margin-top: -5px;
                font-weight: bold;
            }
        }
    }

    :deep(.el-table__body) .el-table__row .el-table__cell {
        // border: none;
    }
    &::before {
        content: none;
    }
}

:deep(.el-table__header) .el-table__cell .cell {
    font-weight: bold;
}

:deep(.el-table__body-wrapper) {
    // height: 100%;
    // overflow: auto;
    min-height: 500px;
}

:deep(.el-table) {
    .special-column {
        &:nth-child(1) {
            color: #2ed573;
        }
    }
}

/* 自定义背景和文字颜色 */
:deep(.el-loading-mask) {
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 100;

    /* 调整加载图标大小 */
    .el-loading-spinner {
        .circular {
            width: 30px;
            height: 30px;

            .path {
                stroke-width: 5px;
                stroke: #1677ff;
            }
        }
    }
}
</style>